import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { News, NewsRepository } from 'src-ironside/repositories/news.repository';

@Component({
    selector: 'app-news-detail-dialog',
    templateUrl: './news-detail-dialog.component.html',
    styleUrls: ['./news-detail-dialog.component.css'],
    providers: [NewsRepository],
})
export class NewsDetailDialogComponent implements OnInit {
    readonly unsubscribe$ = new Subject();

    news?: News;
    constructor(
        private newsRepository: NewsRepository,
        @Inject(MAT_DIALOG_DATA) public data?: { id: string }
    ) {}

    visibleItem: boolean = false;
    itemPdfShow: any;
    pdfLoaded: boolean = false;
    typeFile?: string;

    ngOnInit(): void {
        if (this.data?.id) {
            this.newsRepository
                .findById(this.data?.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res) => {
                    this.news = {
                        ...res,
                        imageURL: res?.photo?.[0]?.url ?? res?.document?.[0]?.url,
                    };
                });
        }
    }

    pageProgress(_event: any) {
        this.pdfLoaded = false;
    }

    pageRendered(_event: any) {
        this.pdfLoaded = true;
    }
    defaultImg = 'src-ironside/assets/images/image-default.jpg';

    openFile(item?: News) {
        const toPdf = { urlFile: item?.document && item?.document?.length > 0 ? item?.document?.[0]?.url : item?.photo?.[0]?.url };
        this.itemPdfShow = toPdf;
        this.visibleItem = true;
        // Convert to lowercase to handle case sensitivity (PDF vs pdf)
        const fileName = this.getNameFile(item);
        const extension = fileName?.split('.').pop()?.toLowerCase();
        // Fallback: check URL directly if getNameFile fails
        const urlFile = item?.document?.[0]?.url?.toLowerCase() || '';
        this.typeFile = extension || (urlFile.includes('.pdf') ? 'pdf' : undefined);
    }

    getNameFile(item: any) {
        const urlFile = item?.document?.[0]?.url.split(
            'https://dev-ironside-elliance-minio.geolane.fr/resource-files/'
        )[1];
        const regex = /([^\/_]+\.[^\/?]+)(?=\?X-Amz|$)/;
        const match = urlFile?.match(regex);
        return match ? decodeURIComponent(match[1]) : undefined;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
